export default "__VITE_ASSET__BbjvN2Zm__"